import { fetchFeedbacks } from '@/features/promo';
import { Env } from '@/shared/config/environment';

const state = {
  feedbacks: null,
  isLoadingFeedbacks: false,
  feedbacksError: null,
};

const mutations = {
  SET_FEEDBACKS: (state, feedbacks) => {
    state.feedbacks = feedbacks;
  },
  SET_LOADING_FEEDBACKS: (state, isLoading) => {
    state.isLoadingFeedbacks = isLoading;
  },
  SET_FEEDBACKS_ERROR: (state, error) => {
    state.feedbacksError = error;
  },
};

const actions = {
  async fetchFeedbacks({ commit, dispatch }) {
    commit('SET_LOADING_FEEDBACKS', true);
    commit('SET_FEEDBACKS_ERROR', null);
    commit('SET_FEEDBACKS', null);

    try {
      const feedbacks = await fetchFeedbacks();
      commit('SET_FEEDBACKS', feedbacks);

      return feedbacks;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити відгуки користувачів';

      commit('SET_FEEDBACKS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити відгуки користувачів',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_FEEDBACKS', false);
    }
  }
};

const getters = {
  isLoadingFeedbacks: (state) => state.isLoadingFeedbacks,
  feedbacksError: (state) => state.feedbacksError,

  isFeedbacksReady: (state) => { return state.isLoadingFeedbacks === false && state.feedbacks !== null; },
  getFeedbacks: (state) => state.feedbacks,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
